import React, { lazy } from 'react';
import { useSelector } from 'react-redux';
import RouterRoutes from 'Helpers/routes/router-routes';
import { registry } from 'Store';
import { getDashboardSteps } from 'Components/dashboard/ducks/selectors';

const OrderPlacedComponent = lazy(() =>
  import(
    /* webpackChunkName: "carvana-order-placed" */ '@carvana/purchase-order-placed'
  )
);

export const OrderPlacedRoute = props => {
  const steps = useSelector(getDashboardSteps);

  return (
    <RouterRoutes
      {...props}
      lazyLoadingText="Loading Order Placed Dashboard"
      isLoadingText="Getting your Order Placed Dashboard"
    >
      <OrderPlacedComponent registry={registry} steps={steps} />
    </RouterRoutes>
  );
};
